import SeatingSection from "common/seating_section_initializer";
import Section from "common/libs/section/section";
import SectionSeatsMapper from "common/libs/section/plugins/seatsMapper";
import SectionNumberNavigation from "common/libs/section/plugins/numberNavigation";
import SectionSingleSeatSelect from "common/libs/section/plugins/singleSeatSelect";
import SectionSeatsDOMRender from "common/libs/section/plugins/seatsDOMRender";
import SectionAreasDOMRender from "common/libs/section/plugins/areasDOMRender";
import SectionDecorationsDOMRender from "common/libs/section/plugins/decorationsDOMRender";
import SectionScaleDesktop from "common/libs/section/plugins/scaleDesktop";
import SectionScaleNavigation from "common/libs/section/plugins/scaleNavigation";
import { assignPriceZoneToSeats } from "common/section/assignPriceZoneToSeats";

window.initializeTicketBuyerSeatingSection = SeatingSection(
  [
    function buildSection(response) {
      var plugins = [];
      var mapFn = function (seat) {
        seat.status = R.includes(seat.status, ["locked", "reserved"])
          ? "sold"
          : seat.status;
        
        if (seat.item_type_ids?.length === 0 && seat.always_visible !== true) {
          seat.status = "sold";
        } else if (
          seat.item_type_ids?.length === 0 &&
          seat.always_visible === true
        ) {
          seat.status = "disabled";
        }
        return seat;
      };

      var numberedSeatsplugins = [
        SectionSeatsMapper(mapFn),
        SectionNumberNavigation,
        SectionSingleSeatSelect,
        new SectionScaleDesktop(),
        SectionSeatsDOMRender,
        SectionAreasDOMRender,
        SectionScaleNavigation,
        SectionDecorationsDOMRender,
      ];

      var unnumberedSeatsPlugins = [
        new SectionScaleDesktop(),
        SectionAreasDOMRender,
      ];

      if (response.seating_arrangements.seats.length > 0) {
        plugins = numberedSeatsplugins;
      } else {
        plugins = unnumberedSeatsPlugins;
      }

      return new Section({
        container: ".arena-container",
        data: assignPriceZoneToSeats(response),
        wrapper: ".tickebuyer-seating-section",
        plugins: plugins,
        selectionFilter: R.allPass([
          R.pipe(R.prop("type"), R.includes(R.__, ["default", "handicap"])),
          R.pipe(R.prop("status"), R.includes(R.__, ["available"])),
        ]),
      });
    },
    function buildSeatsManager(response) {
      return window.ticketbuyerSeatsManager(
        $(".arena-selected-tickets"),
        response
      );
    },
  ],
  function controller(result) {
    var section = result[0];
    var seatsManager = result[1];

    section.$.on("seat:select", function (event, data) {
      var _data = data[0];
      seatsManager.add(
        _data.row,
        _data.seat,
        _data.type,
        _data.item_type_ids,
        _data.area_uuid
      );
    });

    section.$.on("seat:deselect", function (event, data) {
      seatsManager.remove(data[0].row, data[0].seat);
    });

    seatsManager.$.on("seat:remove", function (event, data) {
      section.deselectSeat(data[0], data[1]);
    });
  }
);
